import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Copiar } from '@shared/interfaces/request/copiar';
import { PerfilComponent } from '@pages/perfil/perfil.component';
import { DuplicarService } from '@pages/perfil/services/duplicar.service';
import { SwalService } from '@shared/utils/swal.service';

@Component({
  selector: 'app-duplicar-modelo',
  templateUrl: './duplicar-modelo.component.html',
  styleUrls: ['./duplicar-modelo.component.css']
})
export class DuplicarModeloComponent implements OnInit {
  private readonly _width: string = '900px';
  perfiles: any;
  public breakpoint: number;
  public loading: boolean;
  constructor(
    public _dialog: MatDialog,
    private _dialogRef: MatDialogRef<PerfilComponent>,
    private _fb: UntypedFormBuilder,
    private _swalService: SwalService,
    private _copiarService: DuplicarService
  ) { }


  form = this._fb.group({
    clave: [''],
    descripcion: [''],
    user: ['']
  });

  ngOnInit(): void {
    this.perfiles = JSON.parse(sessionStorage.getItem('perfiles'));
  }

  create(model: Copiar) {
    debugger
    if (this.form.valid) {
      this.loading = true;
      this._copiarService.duplicar(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Copiado');
        } else
          this._swalService.error(
            'No Copiado, Puede ser que la clave ya exista, valide con una diferente por favor!'
          );
      });
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 200 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 200 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }
}
